import { Link } from "react-router-dom";

export default function CtaSection() {
  return (
    <section className="w-full py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-4xl mx-auto relative overflow-hidden rounded-2xl">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20atmosphere%20with%20soft%20golden%20light%20rays%20streaming%20through%20theater%20curtains%2C%20elegant%20dark%20background%20with%20subtle%20texture%2C%20luxurious%20and%20inviting%20movie%20experience%20vibe%2C%20deep%20charcoal%20with%20amber%20and%20gold%20highlights%2C%20no%20text%2C%20cinematic%20quality%208k&width=1200&height=400&seq=cta-bg-movies&orientation=landscape"
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/90 to-background-950/60"></div>

        <div className="relative z-10 py-12 md:py-16 px-6 md:px-12 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="text-xl md:text-3xl font-heading font-bold text-background-50 mb-2">
              每日更新，精彩不断
            </h2>
            <p className="text-sm text-foreground-300 max-w-md">
              海量电影资源每日更新，高清蓝光画质，不缓冲不卡顿，免广告畅享观影体验。
            </p>
          </div>
          <Link
            to="/category/action"
            className="bg-primary-500 hover:bg-primary-600 text-background-950 font-semibold px-8 py-3 rounded-lg text-sm transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            <i className="ri-movie-2-line text-base"></i>
            立即畅享
          </Link>
        </div>
      </div>
    </section>
  );
}